import React, { useState, useEffect } from 'react';
import Followers from '../../static/dashboard/followers.svg';
import Likes from '../../static/dashboard/likes.svg';
import Messaging from '../../static/dashboard/messaging.svg';
import Bump from '../../static/dashboard/bump.svg';
import Star from '../../static/dashboard/star.svg';
import Settings from '../../static/dashboard/settings.svg';
import CloseMenu from '../../static/dashboard/closemenu.svg';
import Signout from '../../static/dashboard/signoutwhite.svg';

export default function DashboardNav({ history, mobileActive, handleMobileClose, handleLogOut }) {
    const currentPath = history.location.pathname;
    const [currentTab, setCurrentTab] = useState("followers");
    const tabList = {
        followers: Followers,
        likes: Likes,
        messaging: Messaging,
        autorelist: Bump,
        boostreviews: Star,
    };
    const mobileMenuList = {
        followers: "Followers",
        likes: "Liking",
        messaging: "Messaging",
        autorelist: "Auto-Relist",
        boostreviews: "Reviews",
        settings: "Settings"
    };

    const handleTabClick = (e) => {
        e.preventDefault();

        setCurrentTab(e.target.id);

        if (mobileActive) {
            handleMobileClose(e);
        }

        if (e.target.id === 'settings') {
            history.push(`/dashboard/${e.target.id}/basicinfo`);
        }
        else {
            history.push(`/dashboard/${e.target.id}`);
        }
    }

    useEffect(() => {
        const locSplit = history.location.pathname.split('/');
        if (locSplit.find(path => path === "settings")) {
            setCurrentTab("settings");
        }
        else {
            const currentTab = locSplit[locSplit.length - 1];

            setCurrentTab(currentTab);            
        }
    }, [history]);

    return (
        <>
            <div className={`mobile-nav ${mobileActive ? 'mobile-active' : ''}`}>
                <img
                className="mobile-close-menu" 
                onClick={handleMobileClose}
                src={CloseMenu} alt="Close Menu"/>
                <ul className="mobile-nav-tabs">
                {
                    Object.keys(mobileMenuList).map((tab) => {
                        if (tab === currentTab) {
                            return (
                                <li
                                className="relative"
                                id={tab}>
                                    <div>&nbsp;</div>
                                    {mobileMenuList[tab]}
                                </li> 
                            )
                        }
                        else {
                            return (
                                <li
                                id={tab}
                                onClick={handleTabClick}>
                                    {mobileMenuList[tab]}
                                </li>
                            )
                        }
                    })
                }
                <li 
                className="signout"
                onClick={(e) => {
                    handleLogOut(e);
                    history.push('/')}}>
                    <img src={Signout} alt="signout" />
                    <span>Sign out</span>
                </li>
                </ul>
            </div>
            <div 
            // style={{height: `calc(${window.innerHeight}px - 3.21em)`}} 
            className={`side-nav ${currentPath === '/dashboard/paymentfailed' ? 'display-none' : ''}`}>
                <ul className="nav-tabs">
                {
                    Object.keys(tabList).map((tab) => {
                        if (tab === currentTab) {
                            return (
                                <li>
                                    <div>&nbsp;</div>
                                    <img 
                                    id={tab} 
                                    src={tabList[tab]} 
                                    alt={tab} />
                                </li>);
                        }
                        else {
                            return (
                            <li>
                                <img 
                                id={tab} 
                                onClick={handleTabClick} 
                                src={tabList[tab]} 
                                alt={tab} />
                            </li>);
                        }
                    })
                }
                </ul>
                <div className="bottom-tabs">
                    {
                        currentTab === "settings" &&
                        <div>&nbsp;</div>
                    }
                    <img 
                    id="settings"
                    onClick={(e) => {
                        handleTabClick(e);
                    }}
                    src={Settings} 
                    alt="Settings"/>
                    <span>v.1.0</span>
                </div>
            </div>
            
        </>
    )
}